import React from "react";
import { Link } from "react-router-dom";

const ZwembadinspectiesMenu = ({ token, username, isActive, onToggle }) => {
  if (username.bedrijf && username.bedrijf.modules.includes("zwembadinspecties")) {
    if (token.role === "admin" || token.role === "manager" || token.role === "medewerker") {
      return (
        <div className="menu-item">
          <div className="menu-link" onClick={onToggle}>
            <span className="menu-icon">
              <i className="fas fa-swimming-pool"></i>
            </span>
            <span className="menu-text">Zwembadinspecties</span>
            <span className={`menu-arrow ${isActive ? "rotate" : ""}`}>
              <i className="fas fa-chevron-right"></i>
            </span>
          </div>
          <div className={`menu-sub ${isActive ? "show" : ""}`}>
            <div className="menu-item">
              <Link to="/zwembadinspecties" className="menu-link">
                <span className="menu-icon">
                  <i className="fas fa-tachometer-alt"></i>
                </span>
                <span className="menu-text">Dashboard</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/zwembadinspecties/zwembaden" className="menu-link">
                <span className="menu-icon">
                  <i className="fas fa-water"></i>
                </span>
                <span className="menu-text">Zwembaden</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/zwembadinspecties/templates" className="menu-link">
                <span className="menu-icon">
                  <i className="fas fa-list-check"></i>
                </span>
                <span className="menu-text">Sjablonen</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/zwembadinspecties/inspecties" className="menu-link">
                <span className="menu-icon">
                  <i className="fas fa-clipboard-list"></i>
                </span>
                <span className="menu-text">Inspecties</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/zwembadinspecties/email-sjablonen" className="menu-link">
                <span className="menu-icon">
                  <i className="fas fa-envelope"></i>
                </span>
                <span className="menu-text">E-mail Sjablonen</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/zwembadinspecties/certificaten" className="menu-link">
                <span className="menu-icon">
                  <i className="fas fa-certificate"></i>
                </span>
                <span className="menu-text">Certificaten</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/zwembadinspecties/conclusie-items" className="menu-link">
                <span className="menu-icon">
                  <i className="fas fa-gavel"></i>
                </span>
                <span className="menu-text">Conclusies</span>
              </Link>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};

export default ZwembadinspectiesMenu;
